import {AbstractService, Expands, Filters} from "./abstract-service";
import {trackPromise} from "react-promise-tracker";
import Api from "./api-config";
import {AxiosResponse} from "axios";
import {Paginated, PaginatedResult} from "../models/default/paginated-result";
import {StockAndMaterialOutput} from "../models/basic/stock-and-material-output";

export type StockAndMaterialOutputFilter = Filters & {
    plant?: string,
    start_date?: string,
    end_date?: string,
    material_number?: string,
};

export class StockAndMaterialOutputService extends AbstractService<StockAndMaterialOutput> {

    constructor() {
        super("/api/purchase-order");
    }

    override processFilters = (filters?: Filters) : Filters | undefined => {
        const processedFilter = {
            ...filters
        };

        if (processedFilter?.plant === "0") {
            delete processedFilter.plant;
        }

        return processedFilter;
    }

    async listStock(filters?: StockAndMaterialOutputFilter, expands?: Expands, pagination?: Paginated): Promise<AxiosResponse<PaginatedResult<StockAndMaterialOutput>>> {
        const path = `${this.path}/stock/report/`;
        const allParams = this.processParameters({...filters}, expands, pagination);
        return await trackPromise(Api.get(path, {params: allParams} ));
    }

    async listPlants(): Promise<AxiosResponse<{ plants: [] }>> {
        const path = `${this.path}/stock/report/list_plants/`;
        return await trackPromise(Api.get(path));
    }

    async listWithdrawal(filters?: StockAndMaterialOutputFilter, expands?: Expands, pagination?: Paginated): Promise<AxiosResponse<PaginatedResult<StockAndMaterialOutput>>> {
        const path = `${this.path}/withdrawal/report/`;
        const allParams = this.processParameters({...filters}, expands, pagination);
        return await trackPromise(Api.get(path, {params: allParams} ));
    }

    async get_export_status(hash: string): Promise<AxiosResponse<{ status: number }>> {
        const path = `${this.path}/stock/report/get_export_status/`;
        return await trackPromise(Api.get(path, {params: {hash}}));
    }

    async export_xlsx(
        filters?: StockAndMaterialOutputFilter,
        expands?: Expands
    ): Promise<AxiosResponse<{ hash: string }>> {
        const path = `${this.path}/stock/report/export_xlsx/`;
        filters = this.processParameters({...filters}, expands);

        return await trackPromise(Api.get(path, {params: filters}));
    }

    async get_last_updated_sap(): Promise<AxiosResponse<{ dt_ultima_atualizacao: string }>> {
        const path = `${this.path}/stock/report/get_last_updated_sap/`;
        return await trackPromise(Api.get(path));
    }
}
